<template>
  <div class="donation-bankaccount">
    <div
      class="donation-bankaccount__content"
      :class="[
        { 'donation-bankaccount__higher-modal': showQr },
        { 'donation-bankaccount__lower-modal': step === 3 },
      ]"
    >
      <span @click="close" class="donation-bankaccount__close">&times;</span>
      <div v-if="step === 1" class="donation-bankaccount__step1">
        <img class="donation-bankaccount__image" src="../assets/bankid.png" />
        <div class="donation-bankaccount__step1-buttons">
          <div class="donation-bankaccount__step1--header">
            {{ modalHeader }}
          </div>
          <div
            v-if="waitingForNextStep === false"
            class="donation-bankaccount__step1--text"
          >
            {{ modalText }}
          </div>
          <div v-else class="donation-bankaccount__step1--text">
            {{ windowWidth > 800 ? qrMessage : qrMessageMobile }}
          </div>

          <div v-if="showQr" class="donation-bankaccount__qr">
            <img :src="qr" />
          </div>
          <div class="donation-bankaccount__step1-buttons--wrapper">
            <button
              class="donation-bankaccount__button-1"
              :class="{
                'donation-bankaccount__spinner': activeSpinnerSame === true,
              }"
              @click.prevent="proceedSameDevice"
            >
              {{ windowWidth > 800 ? sameDevice : sameDeviceMobile }}
            </button>
            <div>
              <a
                class="donation-bankaccount__button-2"
                :class="{
                  'donation-bankaccount__spinner': activeSpinnerOther === true,
                }"
                @click.prevent="proceedAnotherDevice"
              >
                {{ windowWidth > 800 ? anotherDevice : anotherDeviceMobile }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="step === 3" class="donation-bankaccount__step3">
        <label class="donation-bankaccount__step3-label">
          {{ label }}
        </label>
        <select v-model="account">
          <option value="0" disabled="disabled" selected>{{ label }}</option>
          <option
            v-for="acc in bankAccountRetrieval.accounts"
            :key="acc.AccountNo"
            :value="acc"
          >
            {{ acc.Name }} ({{ acc.Number }})
          </option>
        </select>
        <div class="donation-bankaccount__step3-button">
          <button @click="select">{{ submit }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankAccount',

  watch: {
    bankAccountRetrieval: {
      handler: function (value) {
        if (value.status === 'Failed' || value.status === 'Aborted') {
          this.close();
        }
        if (value.status === 'Success' || value.accounts.length > 0) {
          this.step = 3;
        }
      },
      deep: true,
    },
  },

  props: {
    accounts: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: null,
    },
    submit: {
      type: String,
      default: null,
    },
    autoStartToken: {
      type: String,
      default: null,
    },
    qr: {
      type: String,
      default: null,
    },
    qrMessage: {
      type: String,
      required: true,
    },
    qrMessageMobile: {
      type: String,
      required: true,
    },
    sameDevice: {
      type: String,
      required: true,
    },
    anotherDevice: {
      type: String,
      required: true,
    },
    sameDeviceMobile: {
      type: String,
      required: true,
    },
    anotherDeviceMobile: {
      type: String,
      required: true,
    },
    bankAccountRetrieval: {
      type: Object,
      default: () => {},
    },
    header: {
      type: String,
      default: null,
    },
    showQr: {
      type: Boolean,
      default: false,
    },
    modalHeader: {
      type: String,
      default: null,
    },
    modalText: {
      type: String,
      default: null,
    },
    qrBankText: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      account: 0,
      step: 1,
      waitingForNextStep: false,
      activeSpinnerSame: false,
      activeSpinnerOther: false,
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    showAccounts() {
      return (
        this.bankAccountRetrieval.accounts.length &&
        this.bankAccountRetrieval.selected === false
      );
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },

    select() {
      if (this.account != 0) {
        this.$emit('select', this.account);
        this.close();
      }
    },

    proceedAnotherDevice() {
      this.waitingForNextStep = true;
      this.activeSpinnerOther = true;
      this.$emit('proceedAnotherDevice');
    },

    proceedSameDevice() {
      this.waitingForNextStep = true;
      this.activeSpinnerSame = true;
      this.$emit('proceedSameDevice');
    },
  },
};
</script>

<style lang="scss">
.donation-bankaccount {
  position: fixed;
  height: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999;

  @media screen and (max-width: 800px) {
    max-width: 100vw;
  }
  &__content {
    height: 467px;
    background-color: #fff;
    margin: 20px auto;
    position: relative;
    width: 90%;
    width: 340px;
    border-radius: 8px;
    padding: 16px 16px 26px 16px;

    @media screen and (max-width: 800px) {
      max-width: 90vw;
      margin: 50px auto;
    }
  }
  &__spinner {
    background-image: url('../assets/spinner.svg') !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: contain !important;
    font-size: 0 !important;
  }
  &__higher-modal {
    height: 650px;
  }
  &__lower-modal {
    height: 195px;
  }
  &__close {
    color: #000;
    position: absolute;
    top: 0;
    right: 15px;
    font-size: 28px;
    cursor: pointer;
  }
  &__image {
    margin-left: auto;
    margin-right: auto;
    width: 92px;
    height: auto;
  }
  &__header {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 30px;
    align-items: center;
    text-align: center;
    padding: 20px 0px;
  }
  &__spinner {
    margin: 25px 0;
    img {
      margin-left: auto;
      margin-right: auto;
      width: 45px;
    }
  }
  &__step1 {
    max-width: 308px;
    margin: 0 auto;
    &-buttons {
      margin-top: 12px;

      &--wrapper {
        flex-direction: column-reverse;
        display: flex;

        @media screen and (max-width: 800px) {
          flex-direction: column;
        }
      }
    }
    &--header {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: bold;
      font-size: 22px;
      line-height: 30px;
      text-align: center;
      padding: 8px 0px;
    }
    &--text {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
      text-align: center;
      padding: 8px 0px;
      margin-bottom: 12px;
    }
  }
  &__step2 {
    max-width: 308px;
    margin: 0 auto;
  }
  &__button {
    &-1 {
      background-color: #006c81;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      border: none;
      padding: 16px 14px;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 25px;
      cursor: pointer;
      width: 100%;
      color: #006c81;
      background-color: #fff;
      border: 2px solid #006c81;

      @media screen and (max-width: 800px) {
        white-space: nowrap;
        width: 100%;
        font-size: 14px;
        padding: 8px 16px;
        margin-bottom: 15px;
        color: #fff;
        background-color: #006c81;
        height: 54px;
      }
    }
    &-2 {
      display: flex;
      justify-content: center;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      text-decoration: none;
      background-color: #006c81;
      color: #fff !important;
      cursor: pointer;
      border: 2px solid #006c81;
      box-sizing: border-box;
      border-radius: 4px;
      padding: 16px 14px;
      width: 100%;
      margin-bottom: 15px;

      @media screen and (max-width: 800px) {
        white-space: nowrap;
        width: 100% !important;
        font-size: 14px;
        display: flex;
        padding: 8px 16px;
        justify-content: center;
        margin-bottom: 0;
        color: #006c81 !important;
        background-color: #fff;
        height: 54px;
        align-items: center;
      }
    }
  }
  &__qr {
    margin: 20px auto;
    &-message {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
      text-align: center;
      padding: 10px;
    }
    img {
      width: 150px;
      margin-left: auto;
      margin-right: auto;
      border: 1px solid #a5a5a5;
    }
  }
  &__step3 {
    max-width: 308px;
    margin: 16px auto;

    &-label {
      font-family: 'Open Sans';
      font-weight: bold;
      font-size: 22px;
      line-height: 30px;
    }
    select {
      width: 100%;
      margin: 8px 0 0;
      appearance: none;
      background-color: white;
      background-image: url('../assets/chevron-down.svg');
      background-repeat: no-repeat;
      background-position: 96%;
      padding: 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #00000080;
    }
    &-button {
      margin: 16px 0;
      button {
        width: 100%;
        background-color: #006c81;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        border: none;
        padding: 8px 16px;
        color: #fff;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 25px;
        cursor: pointer;
      }
    }
  }
}
</style>
